import {
  GET_HISTORY_LIST_ROUND,
  GET_HISTORY_LIST_ROUND_SUCCESS,
  GET_HISTORY_LIST_ROUND_FAIL,
  GET_HISTORY_LIST_CSR,
  GET_HISTORY_LIST_CSR_SUCCESS,
  GET_HISTORY_LIST_CSR_FAIL,
  GET_RESULT_HISTORY,
  GET_RESULT_HISTORY_SUCCESS,
  GET_RESULT_HISTORY_FAIL,
  SEND_CHAT_MESSAGE,
  SEND_CHAT_MESSAGE_SUCCESS,
  SEND_CHAT_MESSAGE_FAIL,
  SEND_PARTICIPANT_CHAT,
  SEND_PARTICIPANT_CHAT_SUCCESS,
  SEND_PARTICIPANT_CHAT_FAIL,
  GET_PARTICIPANT_HISTORY,
  GET_PARTICIPANT_HISTORY_SUCCESS,
  GET_PARTICIPANT_HISTORY_FAIL,
} from "./actionTypes";

// ----------- Units History list APIs actions -----------------

export const getActivityLogRounds = (id, user_id) => {
  console.log("ID passed to getActivityLogRounds:", id, user_id); // Log both id and type
  return {
    type: GET_HISTORY_LIST_ROUND,
    payload: { id, user_id },
  };
};
export const getActivityLogRoundsSuccess = activitylogRounds => {
  return {
    type: GET_HISTORY_LIST_ROUND_SUCCESS,
    payload: activitylogRounds,
  };
};

export const getActivityLogRoundsFail = error => ({
  type: GET_HISTORY_LIST_ROUND_FAIL,
  payload: error,
});
/////////////////
export const getActivityLogCsr = id => {
  // console.log("ID passed to getActivityLogRounds:", id); // Log both id and type
  return {
    type: GET_HISTORY_LIST_CSR,
    payload: { id }, // Pass both id and type as payload
  };
};

export const getActivityLogCsrSuccess = activitylogCsr => {
  return {
    type: GET_HISTORY_LIST_CSR_SUCCESS,
    payload: activitylogCsr,
  };
};

export const getActivityLogCsrFail = error => ({
  type: GET_HISTORY_LIST_CSR_FAIL,
  payload: error,
});
////////////////////////////
export const getResultHistory = (id, participantId, scheme_id) => {
  // console.log("getResultHistory Actions:", id, participantId, scheme_id); // Log both id and type
  return {
    type: GET_RESULT_HISTORY,
    payload: { id, participantId, scheme_id }, // Pass both id and type as payload
  };
};

export const getResultHistorySuccess = activitylogUnits => {
  return {
    type: GET_RESULT_HISTORY_SUCCESS,
    payload: activitylogUnits,
  };
};

export const getResultHistoryFail = error => ({
  type: GET_RESULT_HISTORY_FAIL,
  payload: error,
});

export const sendChatMessage = data => {
  console.log("Action dispatched → SEND_CHAT_MESSAGE", data);
  return {
    type: SEND_CHAT_MESSAGE,
    payload: data,
  };
};

export const sendChatMessageSuccess = data => ({
  type: SEND_CHAT_MESSAGE_SUCCESS,
  payload: data,
});

export const sendChatMessageFail = error => ({
  type: SEND_CHAT_MESSAGE_FAIL,
  payload: error,
});

export const sendParticipantChat = data => {
  console.log("Action dispatched → SEND_CHAT_MESSAGE", data);
  return {
    type: SEND_PARTICIPANT_CHAT,
    payload: data,
  };
};

export const sendParticipantChatSuccess = data => ({
  type: SEND_PARTICIPANT_CHAT_SUCCESS,
  payload: data,
});

export const sendParticipantChatFail = error => ({
  type: SEND_PARTICIPANT_CHAT_FAIL,
  payload: error,
});

export const getparticipantHistory = id => {
  // console.log("ID passed to getActivityLogRounds:", id); // Log both id and type
  return {
    type: GET_PARTICIPANT_HISTORY,
    payload: { id }, // Pass both id and type as payload
  };
};

export const getparticipantHistorySuccess = activitylogCsr => {
  return {
    type: GET_PARTICIPANT_HISTORY_SUCCESS,
    payload: activitylogCsr,
  };
};

export const getparticipantHistoryFail = error => ({
  type: GET_PARTICIPANT_HISTORY_FAIL,
  payload: error,
});
